<template>
  <div class="grocery-bag-price-splash">
    <svgicon
      v-if="offer"
      class="grocery-bag-price-splash__icon"
      :class="color"
      name="Shop/MatkasseSplash"
    />
    <div class="grocery-bag-price-splash__holder">
      <p v-if="offer && !isSmall">
        Första kassen
      </p>
      <p
        class="grocery-bag-price-splash__amount font-fixed"
        :class="!offer && 'regular-price'"
      >
        {{ currentPrice }}:-<sup
          v-if="offer"
          class="font-fixed"
        >*</sup>
      </p>
      <p v-if="offer && !isSmall">
        ord. pris {{ currentPriceRecommended }}:-/st
      </p>
    </div>
    <p
      v-if="offer && isSmall"
      class="grocery-bag-price__small-caveat"
    >
      Första kassen. Ord. pris {{ currentPriceRecommended }}:-/st 
    </p>
  </div>
</template>

<script>
import "#/Shop/MatkasseSplash"

export default {
  name: 'GroceryBagPriceSplash',
  props: {
    color: {
      type: String,
      default: "red"
    },
    offer: {
      type: Boolean,
      default: false
    },
    currentPrice: {
      type: Number,
      default: null
    },
    currentPriceRecommended: {
      type: Number,
      default: null
    },
  },
  computed: {
    isSmall () {
      return this.$root.isSmallViewport
    }
  }
}
</script>

<style lang="scss">
.grocery-bag-price-splash {
  margin: 0;
  width: 5rem;
  height: 5rem;
  position: relative;

  @include media-breakpoint-up(sm) {
    width: 8.438rem;
    height: 8.438rem;
  }

  &__icon {
    width: 5rem;
    height: 5rem;

    @include media-breakpoint-up(sm) {
      width: 8.438rem;
      height: 8.438rem;
    }

    &.purple {
      path {
        fill: $color-purple-dark;
      }
    }

    &.yellow {
      path {
        fill: $color-yellow-dark;
      }
    }

    &.cyan {
      path {
        fill: $color-turquoise-mid;
      }
    }

    &.orange {
      path {
        fill: $color-orange-mid2;
      }
    }

    &.red {
      path {
        fill: $color-red;
      }
    }

    &.green {
      path {
        fill: $color-green-mid;
      }
    }

    &.blue {
      path {
        fill: $color-blue-dark;
      }
    }
  }

  &__holder {
    position: absolute;
    top: 0;
    left: 0;
    flex-direction: column;
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;
    height: 100%;
    color: $color-white;

    p {
      @include font(text, 1, "normal");

      margin: 0;
      letter-spacing: 0;

      &.grocery-bag-price-splash__amount.font-fixed {
        @include font(rubrik, 2, "black");

        color: $color-white;
        letter-spacing: 0;

        &.regular-price {
          color: $color-black;
        }

        sup {
          font-size: 0.75rem;
          line-height: 1.75rem;
          letter-spacing: 0.0125rem;
        }

        @include media-breakpoint-up(sm) {
          @include font(rubrik, 4, "black");

          sup {
            @include font(rubrik, 2, "normal");
          }
        }
      }
    }
  }

  .grocery-bag-price__small-caveat {
    font-size: 10px;
    font-weight: bold;
  }
}
</style>
